import { render } from "preact";
import { Suspense } from "preact/compat";
import { LocationProvider, lazy, Route, Router } from "preact-iso";

import Home from "#routes/home.js";
import NotFound from "#routes/not-found.js";
import { ErrorBoundary } from "#utils/error.js";

import { ApiClient, ApiClientProvider } from "./api.js";

const root = document.getElementById("root");
if (!root) {
	throw new Error("missing required #root element");
}

const Chat = lazy(() => import("./routes/chat.js"));
const Login = lazy(() => import("./routes/login.js"));

const client = new ApiClient();

render(
	<Suspense fallback="loading...">
		<ErrorBoundary fallback="Error :(">
			<ApiClientProvider client={client}>
				<LocationProvider>
					<Router>
						<Route path="/chat/:chatId" component={Chat} />
						<Route path="/login" component={Login} />
						<Route path="/" component={Home} />
						<Route default component={NotFound} />
					</Router>
				</LocationProvider>
			</ApiClientProvider>
		</ErrorBoundary>
	</Suspense>,
	root,
);
